import ShareButton from './ShareButton';

interface InlineShareProps {
  shareUrl?: string;
}

export default function InlineShare({ shareUrl }: InlineShareProps) {
  return (
    <div className="flex justify-center py-8">
      <ShareButton
        shareUrl={shareUrl}
        iconSize={14}
        iconClassName="opacity-60"
        className="flex min-h-[48px] touch-manipulation select-none items-center gap-1.5 px-4 text-sm font-bold text-gray-60 underline underline-offset-[3px] outline-none active:opacity-60"
        style={{ WebkitTapHighlightColor: 'transparent' }}
      >
        공유하기
      </ShareButton>
    </div>
  );
}
